import styled from "@emotion/styled"
import React, { ClipboardEvent } from "react";
import ContentEditable from "react-contenteditable";
import { COLOR_MAP } from "../../../../constants/ColorNames";
import { Box, Button, Drawer, Grid, Stack } from "@mui/material";
import Placeholder from "./Placeholder";
import PreviewEmail from "./PreviewEmail";
import CircledCrossIcon from "../../../../constants/icons/CircledCrossIcon";
import { RootState } from "../../../../redux/store";
import { useSelector } from "react-redux";
import { capitalizeSentences, checkForEmptyContent, convertToDivs , returnSingularOrPlural} from "../../../../utils/helpers";
import { TabStatesProps } from "../../../../types/dataTypes";
import { BootstrapTooltip } from "../../../../style/tooltips";
import { NOT_ALLOWED_ICON } from "../../../../constants/icons/NotAllowedIcon";
import { renderToStaticMarkup } from "react-dom/server";


const ParentContainer = styled(Grid)`
  display:flex;
  justify-content :space-between ;
  padding: 0.8rem 1.2rem;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 2rem;
  border-bottom: 0.1rem solid ${COLOR_MAP.BORDER_GREY};
  border-top: 0.1rem solid ${COLOR_MAP.BORDER_GREY};
  align-items: center;
`

const SubjectContainer = styled.div`
  display: flex;
  align-items: center;
`

const StyledButton = styled(Button)`
    text-transform: capitalize;
    padding: 0.4rem;
    font-size: 1.2rem;
    line-height: 1.6rem;
    padding: 0.8rem 1.2rem;
`

const StyledCircleIcon = styled(CircledCrossIcon)`
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 68.3rem;
  cursor: pointer;
`

const PreviewModal = styled(Drawer)`
.MuiPaper-root{
  ::-webkit-scrollbar {
  width: 4px; /* Width of the vertical scrollbar */
  display: block;
}
}
`

type SubjectProps = {
    handleSubChange: (event: React.BaseSyntheticEvent, element: string) => void,
    subject: string,
    onDropDownClick: (name: string) => void,
    alreadyGenerated: boolean,
    alreadyRephrased: boolean,
    setActiveElement: (event: any, element: string) => void,
    candidateFullName: string
}
export type Ref = React.MutableRefObject<HTMLInputElement>;
const Subject = React.forwardRef<HTMLInputElement, SubjectProps>((props, ref) => {
    const { handleSubChange, subject, onDropDownClick, alreadyGenerated, alreadyRephrased, setActiveElement, candidateFullName } = props;
    const [showPreviewModal, setShowPreviewModal] = React.useState(false);
    const jobTitle = useSelector((state: RootState) => state.campaign.jobTitle);
    const minExperience = useSelector((state: RootState) => state.campaign.minExperience);
    const maxExperience = useSelector((state: RootState) => state.campaign.maxExperience);
    const companyName = useSelector((state: RootState) => state.campaign.companyName);
    const aboutCompany = useSelector((state: RootState) => state.campaign.aboutCompany);
    const tabState = useSelector((state: RootState) => state.campaign.tabState);

    const isSubjectEmpty = tabState.some((item: TabStatesProps) => checkForEmptyContent(item.subject));
    const isEmailEmpty = tabState.some((item: TabStatesProps) => checkForEmptyContent(item.email));
  
 
    const isEmailMandatoryFeildsFilled = !companyName || !aboutCompany || !jobTitle || !minExperience || !maxExperience || isSubjectEmpty || isEmailEmpty;
    const htmlContent = subject.replaceAll("@fullName", candidateFullName).replaceAll("@jobTitle", jobTitle).replaceAll("@reqexpRange", `${minExperience} ${returnSingularOrPlural(Number(minExperience), 'year', 'years')} to ${maxExperience} ${returnSingularOrPlural(Number(maxExperience), 'year', 'years')}`);

    const closePreviewModal = React.useCallback(()=> {
      setShowPreviewModal(false);
    },[])

    const openPreviewModal = React.useCallback(()=> {
      setShowPreviewModal(true);
    },[])

    // const handlePaste = (e: ClipboardEvent) => {
    //   e.preventDefault();
    //   const isHTML = e.clipboardData.getData("text/html") ? true : false;
    //   const pastedContent = isHTML
    //     ? e.clipboardData.getData("text/html")
    //     : e.clipboardData.getData("text/plain");
  
  
    //   let formattedPastedContent;
    //   if (isHTML) {
    //     // Create a temporary element to parse the pasted content as HTML
    //     const tempDiv = document.createElement("div");
    //     tempDiv.innerHTML = pastedContent;
  
    //     // Call the function to start conversion
    //     convertToDivs(tempDiv);
    //     formattedPastedContent = tempDiv.innerHTML;
    //   }
    //   else {
    //     formattedPastedContent = pastedContent
    //       .split('\n')
    //       .map(line => `<span style="font-size: 1.4rem; line-height: 3rem;">${capitalizeSentences(line)}</span>`)
    //       .join('');
    //   }
  
    //   // Insert the formatted content into the document
    //   const selection = window.getSelection();
    //   if (selection) {
    //     const range = selection.getRangeAt(0);
    //     range.deleteContents();
    //     const fragment = range.createContextualFragment(formattedPastedContent);
    //     range.insertNode(fragment);
    //   }
    // };

 

    return (
    <React.Fragment>
    <ParentContainer >
        <Grid xs={9}>
          <BootstrapTooltip title={alreadyGenerated || alreadyRephrased ? <div style={{ padding: '4px 8px', fontFamily: 'Noto Sans', fontSize: '14px', lineHeight: '22px'}}>Click 'Reset' to add your customised Subject line.</div>: ''}>
            <SubjectContainer>
                <span style={{ color: COLOR_MAP.GREY_DARK }}>Subject:</span>
                <Stack padding='0 1rem' width={'100%'}>
                    <ContentEditable
                        style={{
                            width: '100%',
                            outline: 'none',
                            fontSize: '1.4rem',
                            cursor: (alreadyGenerated || alreadyRephrased )? `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(NOT_ALLOWED_ICON))}"), auto` : 'default',
                            color: (alreadyGenerated || alreadyRephrased) ? COLOR_MAP.BLACK_2 : COLOR_MAP.LIGHT_GREY,
                            backgroundColor: COLOR_MAP.WHITE,
                            lineHeight: '2.2rem',
                            fontFamily: 'Noto Sans'
                          }}
                        innerRef={ref!}
                        html={htmlContent}
                        disabled={alreadyGenerated || alreadyRephrased}
                        onChange={(e: React.BaseSyntheticEvent) => handleSubChange(e, 'subject')}
                        onClick={(e:any) =>setActiveElement(e,'subject')}
                        onBlur={(e)=> null}
                        // onPaste={handlePaste}
                    />
                </Stack>
            </SubjectContainer>
          </BootstrapTooltip>
        </Grid>
        <Grid xs={3} justifyContent='flex-end' display='flex'>
            <Stack flexDirection='row' columnGap={1}>
                <Stack>
                    <Placeholder onDropDownClick={onDropDownClick} />
                </Stack>
                <Stack>
                    <StyledButton disabled={Boolean(isEmailMandatoryFeildsFilled)} disableRipple variant="outlined" onClick={openPreviewModal}>Preview</StyledButton>
                </Stack>
            </Stack>
        </Grid>
    </ParentContainer>
    <PreviewModal  anchor="right" open={showPreviewModal} onClose={closePreviewModal}>
      <StyledCircleIcon onClick ={closePreviewModal}/>
      <PreviewEmail />
   </PreviewModal>
    </React.Fragment>
    )
})
export default Subject